
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';

export const GET_ASSETS_SUCCESS = 'GET_ASSETS_SUCCESS';
export const GET_ASSETS_FROM_BUFFER = 'GET_ASSETS_FROM_BUFFER';
export const REFILL_BUFFER = 'REFILL_BUFFER';
export const ADD_UPLOADING_ASSETS = 'ADD_UPLOADING_ASSETS';
export const ASSET_ERROR = 'ASSET_ERROR';
export const ASSET_UPDATE_PROGRESS = 'ASSET_UPDATE_PROGRESS';
export const ASSET_PERCENT_COMPLETE = 'ASSET_PERCENT_COMPLETE';
export const GET_ASSET_METADATA = 'GET_ASSET_METADATA';
export const UPLOAD_ASSET_DONE = 'UPLOAD_ASSET_DONE';
export const DELETE_ASSET_SUCCESS = 'DELETE_ASSET_SUCCESS';
export const CLEAR_ASSETS = 'CLEAR_ASSETS';

export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const ADD_UPLOADS = 'ADD_UPLOADS';
export const DELETE_UPLOAD = 'DELETE_UPLOAD';
export const CLEAR_UPLOADS = 'CLEAR_UPLOADS';
export const SET_UPLOAD_DATA = 'SET_UPLOAD_DATA';
export const DELETE_KEYWORD = 'DELETE_KEYWORD';

export const SHOW_INFINITE_SCROLL_LOADER = 'SHOW_INFINITE_SCROLL_LOADER';


